import { useIdleTimer } from "react-idle-timer";
import { useRouter } from "next/navigation";
import { useCmsStore } from "./AppHooks";

function ScreenIdleTimer() {
    const router = useRouter();
    const {
        locale,
        storeConfig: {
            timeoutEnable,
            timeoutLength,
        },
    } = useCmsStore()!
    useIdleTimer({
        disabled: !timeoutEnable || timeoutLength === null,
        timeout: 1000 * (Number(timeoutLength) < 15 ? 15 : Number(timeoutLength)),
        onIdle: () => {
            if (!location.pathname.includes("/home") || !location.pathname.includes("/landing")) {
                localStorage.clear();
                sessionStorage.clear();
                const searchParams = new URLSearchParams(location.search);
                searchParams.delete('cocktailId');
                searchParams.delete('noResult');
                router.replace(`/${locale}/home${searchParams.toString() ? `?${searchParams.toString()}` : ''}`);
            }
        },
        debounce: 300,
    });

    return null;
}

export default ScreenIdleTimer;
